import ContentLoader from '@rio-cloud/rio-uikit/ContentLoader';

const TransportOrderDetailSkeleton = () => (
    <div role='status' aria-label='Loading transport order' aria-busy>
        <ContentLoader width='45%' height={20} className='margin-bottom-20' />
        <ContentLoader width='25%' height={18} className='margin-bottom-20' />
        <div className='display-grid grid-cols-2 gap-20'>
            <ContentLoader width='60%' />
            <ContentLoader width='60%' />
            <ContentLoader width='85%' />
            <ContentLoader width='85%' />
            <ContentLoader width='60%' />
            <ContentLoader width='60%' />
        </div>
    </div>
);

export default TransportOrderDetailSkeleton;
